const Login = () => import("./components/Login.vue");
const Profile = () => import("./components/Profile.vue");
const FirstForm = () => import("./components/FirstForm.vue");
const Products = () => import("./components/Products/Products.vue");
const ProductDetails = () => import("./components/Products/ProductDetails.vue");
const AddProduct = () => import("./components/Products/AddProduct.vue");
const NewCategoryForm = () => import("./components/AddCategory.vue");
const EditCategory = () => import("./components/EditCategory.vue");
const Partners = () => import("./components/Partners.vue");
const Places = () => import("./components/Places.vue");
const Banner = () => import("./components/Banner.vue");
const HomeSections = () => import("./components/HomeSections.vue");
const GeneralCoupons = () => import("./components/GeneralCoupons.vue");
const ThreeStepsSection = () => import("./components/ThreeStepsSection.vue");
const Faq = () => import("./components/faq.vue");
const ContactEmails = () => import("./components/ContactEmails.vue");
const PrivacyPolicy = () => import("./components/PrivacyPolicy.vue");
const DeliveryPolicy = () => import("./components/DeliveryPolicy.vue");
const Terms = () => import("./components/Terms.vue");
const PullBackPolicy = () => import("./components/PullBackPolicy.vue");
const Users = () => import("./components/Users.vue");
const Banks = () => import("./components/Banks.vue");
const Branches = () => import("./components/Branches.vue");
const Orders = () => import("./components/Orders.vue");
// import FabricStocks  "./components/FabricStocks.vue";
const Admins = () => import("./components/Admins.vue");
const AddFabric = () => import("./components/AddFabric.vue");
const AddYaka = () => import("./components/AddYaka.vue");
const AddZarzour = () => import("./components/AddZarzour.vue");
const AddAkmam = () => import("./components/AddAkmam.vue");
const AddBetana = () => import("./components/AddBetana.vue");
const AddAccessory = () => import("./components/AddAccessory.vue");
const AddColor = () => import("./components/AddColor.vue");
const Info = () => import("./components/Info.vue");
const Sms = () => import("./components/Sms.vue");
const AllOrders = () => import("./components/AllOrders.vue");
const Fabrics = () => import("./components/Fabrics.vue");
const Sizes = () => import("./components/Sizes.vue");
const AddShoeColor = () => import("./components/AddShoeColor.vue");
const NewsLetter = () => import("./components/newsletter.vue")
const AppMessages = () => import("./components/AppMessages.vue")
const Carts = () => import("./components/Carts.vue")
const TailorRequests = () => import("./components/tailorRequests.vue")
const WinterCollectionSizes = () => import("./components/WinterCollectionSizes.vue")

export const routes = [
  {path: "/login", component: Login},
  {
    path: "/manage-product",
    component: Profile,
    children: [
      {path: "/", component: Products},
      {path: "/manage-product/firstform", component: FirstForm},
      {path: "/add-product", component: AddProduct},
      {
        path: "/manage-product/product-details/:slug",
        component: ProductDetails,
        props: true,
        name: "productDetails"
      },
      {path: "/banks", component: Banks},
      {path: "/branches", component: Branches},
      {path: "/users/:id/orders/:orderId", component: Orders},
      {path: "/users/:id/orders", component: Orders},
      // { path: "/fabric-stocks", component: FabricStocks }
    ]
  },

  {path: "/AddCategory", component: NewCategoryForm},
  {path: "/EditCategory/:categoryType", component: EditCategory},
  {path: "/Partners", component: Partners},
  {path: "/Places", component: Places},
  {path: "/Banner", component: Banner},
  {path: "/home-sections", component: HomeSections},
  {path: "/general-coupons", component: GeneralCoupons},
  {path: "/ThreeStepsSection", component: ThreeStepsSection},
  {path: "/Users", component: Users},
  {path: "/Questions", component: Faq},
  {path: "/contact-emails", component: ContactEmails},
  {path: "/privacy-policy", component: PrivacyPolicy},
  {path: "/delivery-policy", component: DeliveryPolicy},
  {path: "/terms", component: Terms},
  {path: "/pull-back-policy", component: PullBackPolicy},
  {path: "/Admins", component: Admins},
  {path: "/AddFabric", component: AddFabric},
  {path: "/ShoesColors", component: AddShoeColor},
  {path: "/Fabrics", component: Fabrics},
  {path: "/Sizes", component: Sizes},
  {path: "/AddYaka", component: AddYaka},
  {path: "/AddZarzour", component: AddZarzour},
  {path: "/AddAkmam", component: AddAkmam},
  {path: "/AddBetana", component: AddBetana},
  {path: "/AddAccessory", component: AddAccessory},
  {path: "/AddColor", component: AddColor},
  {path: "/Info", component: Info},
  {path: "/Sms", component: Sms},
  {path: "/all-orders", component: AllOrders},
  {path: "/newsletter-subscripers", component: NewsLetter},
  {path: "/app-messages", component: AppMessages},
  {path: "/users-carts", component: Carts},
  {path: "/tailor-orders", component: TailorRequests},
  {path: "/winter-collection-sizes", component: WinterCollectionSizes},
  {path: "*", redirect: "/login"}
];
